import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 320px;
  margin-top: 30px;
`

export const BoxLegend = styled.div`
  text-align: center;
`

export const Label = styled.span`
  display: block;
  margin-bottom: 10px;
  color: #000000;
  font-size: 0.875rem;
`

export const Legend = styled.span`
  margin: 0 10px;
  color: #263238;
  font-size: 0.75rem;
  
  &:before {
    content: "";
    width: 12px;
    height: 12px;
    margin-right: 5px;
    display: inline-block;
    background-color: ${props => props.color};
    border-radius: 50%;
  }
`

export const Type = styled.span`
  &:before {
    content: "";
    width: 12px;
    height: 12px;
    margin-right: 5px;
    display: inline-block;
    background-color: ${props => props.color};
    border-radius: 50%;
  }
`

export const BoxTooltip = styled.div`
  background: #FFFFFF;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 8px;
`

export const Item = styled.span`
  display: block;
  font-size: 0.75rem;
  line-height: 1.4em;
`
